import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { NonAuthRoutes, Modules, AuthRoutes, RoleCodes } from '../../../enums';
import { AuthContext } from '../../../contexts/AuthContext';
import Brand from './Brand';
import LoginIllustrations from './LoginIllustration';
import ForgotPasswordIllustrations from './ForgotPasswordIllustrations';
import ResetPasswordIllustrations from './ResetPasswordIllustrations';

interface PublicLayoutProps {
  route: NonAuthRoutes;
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ route, children }) => {
  const { token, loggedInUser } = useContext(AuthContext);

  if (token) {
    const destination = loggedInUser?.role_code === RoleCodes.inspector
      ? Modules.propertyVisits
      : Modules.home + AuthRoutes.dashboard;
    return <Navigate replace to={{ pathname: destination }} />;
  }

  let illustration;
  if (route === NonAuthRoutes.login) {
    illustration = <LoginIllustrations />;
  } else if (route === NonAuthRoutes.forgotPassword) {
    illustration = <ForgotPasswordIllustrations />;
  } else if (route === NonAuthRoutes.resetPassword) {
    illustration = <ResetPasswordIllustrations />;
  }

  return (
    <main className="login-main">
      <div className="authentication-wrapper authentication-cover">
        <Brand />
        <div className="authentication-inner row m-0">
          <div className='d-none d-lg-flex col-lg-7 col-xl-8 align-items-center justify-content-center p-0'>
            {illustration}
          </div>
          <div className="d-flex col-12 col-lg-5 col-xl-4 align-items-center authentication-bg position-relative py-sm-12 px-12 py-6">
            {children}
          </div>
        </div>
      </div>
    </main>
  );
};

export default PublicLayout;
